import React from 'react'
import Dashboard from '../components/Dashboard'

export default function DashboardContainer() {
  return <Dashboard />
}
